var email_check = new RegExp(/^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i);

$(document).ready(function() {

    $('.slider').each(function(index) {

        var s_slidesToShow = parseFloat($(this).attr('data-slides-to-show'));
        var s_loop = $(this).attr('data-loop').toLowerCase() == 'true' ? true : false;
        var s_dots = $(this).attr('data-dots').toLowerCase() == 'true' ? true : false;
        var s_showArrow = $(this).attr('data-arrow').toLowerCase() == 'true' ? true : false;
        var s_slidesToShowTablet = parseFloat($(this).attr('data-tablet-slides'));
        var s_slidesToShowMobile = parseFloat($(this).attr('data-mobile-slides'));
        var s_asNavFor = null;
        var s_adaptiveHeight = false;
        var s_variableWidth = false;
        var s_focusOnSelect = false;
        var s_accessibility = false;
        if ($(this).attr('data-asNavFor')) {
            s_asNavFor = $(this).attr('data-asNavFor');
        }
        if ($(this).attr('data-adaptiveHeight')) {
            s_adaptiveHeight = $(this).attr('data-adaptiveHeight').toLowerCase() == 'true' ? true : false;
        }
        if ($(this).attr('data-variableWidth')) {
            s_variableWidth = $(this).attr('data-variableWidth').toLowerCase() == 'true' ? true : false;
        }
        if ($(this).attr('data-focusOnSelect')) {
            s_focusOnSelect = $(this).attr('data-focusOnSelect').toLowerCase() == 'true' ? true : false;
        }
        if ($(this).attr('data-accessibility')) {
            s_accessibility = $(this).attr('data-accessibility').toLowerCase() == 'true' ? true : false;
        }
        $(this).slick({
            infinite: s_loop,
            slidesToShow: s_slidesToShow,
            arrows: s_showArrow,
            slidesToScroll: 1,
            dots: s_dots,
            asNavFor: s_asNavFor,
            adaptiveHeight: s_adaptiveHeight,
            focusOnSelect: s_focusOnSelect,
            accessibility: s_accessibility,
            variableWidth: s_variableWidth,
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: s_slidesToShowTablet,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: s_slidesToShowMobile,
                        slidesToScroll: 1,

                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
    });

    $('.the-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.slider-buttons a.active').removeClass('active');
        $('.slider-buttons a').eq(nextSlide).addClass('active');
    });
    $(".slider-buttons a").click(function(e) {
        e.preventDefault();
        $('.slider-buttons a.active').removeClass('active');
        $(this).addClass('active');
        let slideIndex = $(this).index();
        $('.the-slider').slick('slickGoTo', parseInt(slideIndex));
    });
   // $('.the-slider').slick('slickGoTo', 1);

    //lets talk
    //lets talk floating label
    var formFields = $('.indepth-form-modal .form-col,.lets-talk-modal .form-col , .input-wrap, .register-event-body .form-col, .user-register-section .form-col, .contact-form .form-col');
    formFields.each(function() {
        var field = $(this);
        var input = field.find('.form-control , .form-control-wrapper input, .form-control-wrapper select');
        var label = field.find('label');

        function checkInput() {
            var valueLength = input && input.val() ? input.val().length : 0;
            if (input.attr('type') == 'number') {
                if (valueLength > 0 || !document.getElementById(input.attr("id")).checkValidity()) {
                    label.addClass('freeze')
                } else {
                    label.removeClass('freeze')
                }
            } else {
                if (valueLength > 0) {
                    label.addClass('freeze')
                } else {
                    label.removeClass('freeze');
                }
            }
        }

        function checkInputVlaues() {
            var valueLength = input && input.val() ? input.val().length : 0;
            if (input.attr('type') == 'number') {
                if (valueLength == 0 && document.getElementById(input.attr("id")).checkValidity()) {
                    label.removeClass('freeze');
                }
            } else {
                if (valueLength == 0) {
                    label.removeClass('freeze');
                }
            }
        }
        checkInput();
        input.change(function() {
            checkInput()
        });
        input.focus(function() {
            label.addClass('freeze');
        }).blur(function() {
            checkInputVlaues();
        });

    });

    // Submit form
    $("#DSFormBtn").click(function(e) {
        buttonClicked(e)
    });

    $('.move-up').click(function() {
       // $('html').animate({
          //  scrollTop: $("#WebinarBusinessContinuity").offset().top
      //  }, 500);
    });


});


/**
 * Generate Recaptcha token and call form submission function
 *
 * @param e
 */
function buttonClicked(e) {
    e.preventDefault();

    // generate recaptcha token
    grecaptcha.ready(function() {
        var token = grecaptcha.execute( _wpcf7_recpatcha_site_key, { action: 'subscribe_campain' }).then(function(token) {
            return formSubmit(token, "subscribe_campain")
        });
    });
}


/**
 * Submit and validate the form
 *
 * @param token
 * @returns {boolean}
 */
function formSubmit(token, action) {
    var isFormValid = ValidateForm();
    submitFormCallStarted();

    var agree = "No";
    var checkedValue = $('.MyAgree:checked').val();
    if (checkedValue == "on") {
        agree = "Yes";
    }
    if (isFormValid) {
        var messageObj = {
            Full_Name: $('.MyName').val(),
            Job_Title: $('.JobTitle').val(),
            Mobile: $('.MyPhone').val(),
            Business_Email: $('.BusinessEmail').val(),
            Organization_Name: $('.MyOrg').val(),
            Receive_Commercial_Information: agree,
            token: token,
            action: action
        };

        var recaptcha_response = $('textarea.g-recaptcha-response');
        if (recaptcha_response) messageObj['g-recaptcha-response'] = recaptcha_response.val(),

        $.ajax({
            type: 'post',
            url: 'form-submit.php',
            data: { submitted_data: messageObj },
        })
            .done(successCallback)
            .fail(submitFormCallFailed)
            .always(submitFormCallFinished);

        //$("#DSFormBtn").attr("disabled", false);
    }
    //$("#DSFormBtn").attr("disabled", true);
    return false;
}
var letsTalkModal = $('.lets-talk-modal');
var letsTalkClose = $('.lets-talk-modal .hide-modal');
var eventClose = $('.event-reg-modal .hide-modal');
var letsTalkBackdrop = $('.c-modal-backdrop');

letsTalkBackdrop.click(function(){
    closeLetsTalkModal()
})
function openLetsTalkModal() {

    letsTalkModal.slideDown(400, function() {
        $(this).addClass('opened');
        letsTalkBackdrop.fadeIn();
        $('body').addClass('unscrollable');
        $('.inner-banner .container').css('z-index', '13');
        $('header.site-header').css('z-index', '1');
    });
}
document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#"]');

    if (link === null) {
      return;
    }

    event.preventDefault();
  });
function closeLetsTalkModal() {

    letsTalkModal.removeClass('opened').slideUp(400);
    letsTalkBackdrop.fadeOut();
    $('body').removeClass('unscrollable');
    $('.inner-banner .container').css('z-index', '')
    $('header.site-header').css('z-index', '');
}
function successCallback() {

    $('.MyForm').hide();
    $('.success-msg').show();
    $("#DSFormBtn").attr("disabled", false);

    removeFormError();
}


function ValidateForm() {
    var result = true;

    $('.MyName').removeClass('warning');
    $('.MyOrg').removeClass('warning');
    $('.BusinessEmail').removeClass('warning');
    $('.MyPhone').removeClass('warning');
    $('.JobTitle').removeClass('warning');
    $('.MyAgree').removeClass('warning');


    if (!email_check.test($('.BusinessEmail').val())) {
        $('.BusinessEmail').addClass('warning');
        result = false;
    }

    if ($('.MyName').val().trim() == '') {
        $('.MyName').addClass('warning');
        result = false;
    }
    if ($('.MyOrg').val().trim() == '') {
        $('.MyOrg').addClass('warning');
        result = false;
    }

    if ($('.JobTitle').val().trim() == '') {
        $('.JobTitle').addClass('warning');
        result = false;
    }


    if ($('.MyPhone').val().trim() == '') {
        $('.MyPhone').addClass('warning');
        result = false;
    }

    return result;
}


/* submit form callbacks */

function submitFormCallStarted()
{
    removeFormError();
    setSubmitFormDisabledAttr(true);
    setFormLoading(true);
}

function submitFormCallFinished()
{
    setSubmitFormDisabledAttr( false );
    setFormLoading(false);
}

function submitFormCallFailed({ responseText })
{
    let response = JSON.parse(responseText),
        errorMsg = response ? response.msg || null : 'Something went wrong!';
    setFormError(response.key || null, errorMsg);
}


/* helper functions */

function setSubmitFormDisabledAttr( disabled = null )
{
    let submitBtn = document.getElementById('DSFormBtn')
    if (submitBtn) submitBtn.disabled = disabled == null ? !submitBtn.disabled : disabled;
}

function setFormLoading(loading = true)
{
    let loader = document.getElementById('form-submit-btn-loader');
    loading ? $(loader).show() : $(loader).hide();
}

function setFormError(key, error)
{
    let recaptcha_error = document.getElementById('contact-form-error');
    if (key == 'recaptcha-v2') {
        if (recaptcha_error) {
            recaptcha_error.innerHTML = error;
        } else {
            recaptcha_error = document.createElement('DIV');
            recaptcha_error.id = 'contact-form-error';
            recaptcha_error.className = 'text-danger pt-2';
            recaptcha_error.style = 'font-size: 0.65rem; font-weight: 600;';
            recaptcha_error.innerHTML = error;

            let container = document.querySelector('.form-col.g-recaptcha');
            container.appendChild(recaptcha_error);
        }
    } else recaptcha_error ? recaptcha_error.remove() : null;
}

function removeFormError()
{
    let recaptcha_error = document.getElementById('contact-form-error');
    if (recaptcha_error) recaptcha_error.remove();
}